import { GatsbyContactPage } from 'src/features/contact'

export default GatsbyContactPage
